import { FIELD__list_lora } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_lora';
import { createColumnHelper } from '@tanstack/react-table';
import { useMemo } from 'react';
import { HOOK_TABLE_LAYOUT__inputs__base } from '../_base/HOOK_TABLE_LAYOUT__inputs__base';

interface PROPS {
  fields: FIELD__list_lora[];
}

const helper_column = createColumnHelper<FIELD__list_lora>();

export function HOOK_TABLE_LAYOUT__inputs__model_lora({ fields }: PROPS) {
  /*
   *
   */

  const columns__additional = useMemo(
    () => [
      // Actions
      // helper_column.accessor(field => field, {
      //   id: 'actions',
      //   header: 'actions',
      //   cell: info => (
      //     <G_TABLE_CELL__inputs_images__buttons_base field={info.getValue()}>
      //       <></>
      //     </G_TABLE_CELL__inputs_images__buttons_base>
      //   ),
      // }),
      helper_column.accessor(row => row, {
        id: 'items_amount',
        header: 'Items',
        cell: info => render_cell_items_amount(info.getValue()),
      }),

      // Preview
    ],
    [],
  );

  /*
   *
   */

  /*
   *
   */

  function render_cell_items_amount(field: FIELD__list_lora) {
    return <span className="font-mono">{`${field.items.length} items`}</span>;
  }

  return HOOK_TABLE_LAYOUT__inputs__base({ fields, columns__additional });
}
